import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { InstallationsMigrationStore, MigrationStatus } from '@store';

import { InstallationMigrationModalComponent } from '../installation-migration-modal/installation-migration-modal.component';

@Component({
  selector: 'app-installation-migration-confirmation',
  templateUrl: './installation-migration-confirmation-modal.component.html',
  styleUrls: ['./installation-migration-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationMigrationConfirmationModalComponent implements OnDestroy {
  @Output() finishSuccess = new EventEmitter();
  @Output() finishError = new EventEmitter();
  @Output() previousStep = new EventEmitter();
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationsMigrationStore: InstallationsMigrationStore,
    private dialogRef: MatDialogRef<InstallationMigrationModalComponent>,
    private translateService: TranslateService
  ) {}

  onBack(): void {
    this.installationsMigrationStore.clearLoadedInstallations();
    this.previousStep.emit();
  }

  onClose(): void {
    this.installationsMigrationStore.clearCachedData();
    this.dialogRef.close();
  }

  onMigrateInstallations(): void {
    this.installationsMigrationStore.migrateInstallations();

    this.subscribeToMigrationStatus();
  }

  getInstallationsCount(installationsToMigrate: string[]): number | string {
    return installationsToMigrate.length > 0
      ? installationsToMigrate.length
      : this.translateService.instant('+INSTALLATIONS_MIGRATION.ALL_INSTALLATIONS');
  }

  private subscribeToMigrationStatus(): void {
    this.installationsMigrationStore.migrationStatus$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((status) => [MigrationStatus.SUCCESS, MigrationStatus.ERROR].includes(status))
      )
      .subscribe((status) => {
        if (status === MigrationStatus.SUCCESS) {
          this.installationsMigrationStore.clearCachedData();
          this.finishSuccess.emit();
        } else {
          this.finishError.emit();
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
